import {createI18n} from 'vue-i18n'

const datetimeFormats = {
    'en': {
        datetime: {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: 'numeric',
            minute: 'numeric',
        },
        // "short2" to prevent collision with often used name "short"
        short2: {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit'
        },
        wday: {
            weekday: 'short'
        },
        time: {
            hour: 'numeric',
            minute: 'numeric',
            hour12: true
        },
    },
    'de': {
        datetime: {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: 'numeric',
            minute: 'numeric',
        },
        short2: {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit'
        },
        wday: {
            weekday: 'short'
        },
        time: {
            hour: 'numeric',
            minute: 'numeric',
        },
    }
}


const i18n = createI18n({
    locale: process.env.VUE_APP_I18N_LOCALE || 'de',
    fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'de',
    datetimeFormats
})
export default i18n
